





























































import { Vue, Component, Watch } from 'vue-property-decorator';
import { formRules } from '@/common/util/validator';
import { TbShopAccount, TbShop,TbTbHandover } from '@/http';
import { Toast, Dialog } from 'vant';
import { padHeadPanel, logoutPanel,addByjPanel } from "@/components"

import { State, Getter, Action, Mutation, namespace } from 'vuex-class'
var md5 = require("js-md5");
@Component({
    components: { padHeadPanel, logoutPanel,addByjPanel },
})
export default class Login2 extends Vue {

    form = {
        /**店铺编号 */
        shopno: "",
        /**员工号 */
        jobNumber: "",
        /**密码 */
        pwd: "",
    }

    checked = false;
    isLoading = false;

    /**记住的登录信息 */
    loginInfo: any = {};

    dialogShow = false;

    showPopover = false;

    loginEdList: any = {};

    /**备用金弹窗 */
    addimprestShow = false;


    async mounted() {
        this.loginInfo = JSON.parse(localStorage.getItem("loginInfo"));
        this.checked = localStorage.getItem("isRememberPwd") && localStorage.getItem("isRememberPwd") == "true" ? true : false;
        this.form.shopno = this.loginInfo.shopNo;
        if (this.checked) {
            this.form.jobNumber = this.loginInfo.jobNumber;
            this.form.pwd = this.loginInfo.pwd;
        } else {
            this.form.jobNumber = this.loginInfo.jobNumber;
            this.form.pwd = "";

        }

        this.loginEdList = localStorage.getItem('loginEdList') ? JSON.parse(localStorage.getItem('loginEdList')) : {};

    }
    async created() {

    }
    async loginFun() {
        if (this.isLoading) return;
        if (!this.form.shopno) {
            Toast("请输入店铺编号")
            return;
        }
        if (!this.form.jobNumber) {
            Toast("请输入手机号/员工号")
            return;
        }
        if (!this.form.pwd) {
            Toast("请输入密码")
            return;
        }
        this.isLoading = true;
        try {
            let res = await TbShopAccount.GetWebUsersLogin({
                shopno: this.form.shopno,
                jobNumber: this.form.jobNumber,
                pwd: md5(this.form.pwd),
            });
            localStorage.setItem("padToken", res.token);
            localStorage.setItem("padUserinfo", JSON.stringify(res));
            if (window.webkit) {
                if (res.isJewelry) {
                    window.webkit.messageHandlers.setPageSize.postMessage(3);
                } else {
                    window.webkit.messageHandlers.setPageSize.postMessage(1);
                }
                window.webkit.messageHandlers.searchForBluetooth.postMessage('searchForBluetooth');
            }
            localStorage.setItem("appAuth", res.appAuth);
            let resShop = await TbShop.GetTbShopById({ id: res.shopId })
            localStorage.setItem("padShopInfo", JSON.stringify(resShop))
            let form = Object.assign({}, res, {
                pwd: this.form.pwd,
                shopNo: resShop.shopNo
            })
            localStorage.setItem("loginInfo", JSON.stringify(form))
            let resVersion = await TbShopAccount.GetVersion({ versionType: 4 });
            localStorage.setItem('versionIno', JSON.stringify(resVersion));
            if (this.checked) {
                localStorage.setItem("isRememberPwd", 'true')
            } else {
                localStorage.setItem("isRememberPwd", 'false')
            }
            this.isLoading = false;
            if (localStorage.getItem('loginEdList')) {
                let loginEdList = localStorage.getItem('loginEdList') ? JSON.parse(localStorage.getItem('loginEdList')) : {};
                if (resShop.shopNo == loginEdList.shopNo) {
                    let index = loginEdList.list.findIndex(v => v.jobNumber == this.form.jobNumber)
                    if (index > -1) {
                        loginEdList.list[index].jobNumber = this.form.jobNumber;
                        loginEdList.list[index].pwd = this.form.pwd;
                        loginEdList.list[index].isRemeber = this.checked;
                    } else {
                        loginEdList.list.push({
                            pwd: this.form.pwd,
                            jobNumber: this.form.jobNumber,
                            isRemeber: this.checked
                        })
                    }
                    localStorage.setItem('loginEdList', JSON.stringify(loginEdList));
                } else {
                    localStorage.removeItem('loginEdList');
                    let obj = {
                        shopNo: resShop.shopNo,
                        list: [{
                            pwd: this.form.pwd,
                            jobNumber: this.form.jobNumber,
                            isRemeber: this.checked
                        }]
                    }
                    localStorage.setItem('loginEdList', JSON.stringify(obj));
                }
            } else {
                let obj = {
                    shopNo: resShop.shopNo,
                    list: [{
                        pwd: this.form.pwd,
                        jobNumber: this.form.jobNumber,
                        isRemeber: this.checked
                    }]
                }
                localStorage.setItem('loginEdList', JSON.stringify(obj));
            }
            if (!res.isUpdate) {
                this.$router.push("/pad/shopUpdate");
            } else {
                /**是否开启备用金 */
                let resByj = await TbShop.GetInitShopInfo({shopId:JSON.parse(localStorage.getItem('padShopInfo')).id});
                if(resByj.isOpenImprest){
                    // 登录成功后，判断登录账号的“是否已交接班”状态；
                    let resIsjjb = await TbTbHandover.GetHandowerTime({
                        accountId:JSON.parse(localStorage.getItem("padUserinfo")).id,
                    });
                    console.log('resIsjjb',resIsjjb);
                    if(resIsjjb.startTime) {
                        let resAddByj = await TbShopAccount.AddTbImprest({
                            handoverId:JSON.parse(localStorage.getItem("padUserinfo")).id,
                            money:0
                        });
                        this.$router.push("/pad/mainPage/index");
                    }else{
                        this.addimprestShow = true;
                    }
                }else{
                    let resAddByj = await TbShopAccount.AddTbImprest({
                        handoverId:JSON.parse(localStorage.getItem("padUserinfo")).id,
                        money:0
                    });
                    this.$router.push("/pad/mainPage/index");
                }
            }

            // if (window.webkit) {
            //     window.webkit.messageHandlers.getVersion.postMessage('getVersion');
            // }

        } catch (error) {
            this.isLoading = false;
        }
    }
    closeFun(){
        this.addimprestShow = false;
        this.$router.push("/pad/mainPage/index");
    }

    logoutFun() {
        this.dialogShow = true;
    }

    cancelFun() {
        this.dialogShow = false;
    }
    async confimrFun() {
        this.dialogShow = false;
        let labelPrinterName = localStorage.getItem('labelPrinterName');
        let receiptPrinterName = localStorage.getItem('receiptPrinterName');
        localStorage.clear();
        localStorage.setItem('labelPrinterName', labelPrinterName);
        localStorage.setItem('receiptPrinterName', receiptPrinterName);
        localStorage.setItem("isPad",'true');

        this.$router.push("/pad/padLogin");
    }
    chooseFun(item) {
        this.form.jobNumber = item.jobNumber;
        if (item.isRemeber) {
            this.form.pwd = item.pwd;
        } else {
            this.form.pwd = "";
        }
        this.showPopover = false;
    }


}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/views/padViews/Login2.vue